import { P44Theme, makeP44Styles } from '../../utils/theme';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

// Default color, most likely to be used this way most or all the time, easy to override.
const useStyles = makeP44Styles((theme: P44Theme) => ({
  root: {
    color: theme.palette.green[400],
  },
}));

const ProgressCompletedIcon = (props: SvgIconProps) => {
  const classes = useStyles(props);
  return (
    <SvgIcon classes={{ root: classes.root }} {...props} viewBox="0 0 24 24">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(2.000000, 2.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <path
            d="M10,0 C15.5228475,0 20,4.4771525 20,10 C20,12.6521649 18.9464316,15.195704 17.0710678,17.0710678 C15.195704,18.9464316 12.6521649,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M14.1285714,5.99171668 C13.7476607,5.99171668 13.3825237,6.14383907 13.1142857,6.41428571 L13.1142857,6.41428571 L8.7,10.8285714 C8.63392742,10.8903685 8.54757221,10.9259265 8.45714286,10.9285714 C8.36252063,10.9255972 8.2717711,10.8903057 8.2,10.8285714 L8.2,10.8285714 L6.88571429,9.5 C6.5233449,9.13763062 5.99518002,8.99610926 5.50017423,9.12874566 C5.00516845,9.26138206 4.61852492,9.64802559 4.48588852,10.1430314 C4.35325212,10.6380372 4.49477347,11.166202 4.85714286,11.5285714 L4.85714286,11.5285714 L7.41428571,14.1428571 C7.68153062,14.4155081 8.04679158,14.5698437 8.42857143,14.5714286 C8.80538467,14.5660614 9.16481363,14.4120204 9.42857143,14.1428571 L9.42857143,14.1428571 L15.1428571,8.42857143 C15.696748,7.87137507 15.696748,6.97148208 15.1428571,6.41428571 C14.8746191,6.14383907 14.5094822,5.99171668 14.1285714,5.99171668 Z"
            id="Shape"
          ></path>
        </g>
        <rect x="0" y="0" width="24" height="24"></rect>
      </g>
    </SvgIcon>
  );
};

export default ProgressCompletedIcon;
